import styled from 'styled-components';

export const RippleEmptyButton = styled.div`
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
`;

export const Root = styled.button<{ disabled?: boolean; fullWidth?: boolean }>`
  position: relative;
  border: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
  border-radius: 8px;
  padding: 24px 16px;
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  color: ${({ disabled, theme }) =>
    disabled ? theme.colors.text.lightGrey : theme.colors.text.darkerGrey};
  fill: ${({ disabled, theme }) =>
    disabled ? theme.colors.text.lightGrey : theme.colors.text.darkerGrey};
  background: ${({ theme }) => theme.colors.background.white};
  ${({ theme }) => theme.typography.RegularParagraphBold}
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  transition: background-color 200ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.superLightGrey};
  }
`;
